<template>
  <div class="services-page">
    <Header />
    
    <!-- 页面标题区域 -->
    <section class="page-header">
      <div class="container">
        <div class="header-content">
          <h1 class="page-title">检验检测服务</h1>
          <p class="page-subtitle">专业、可靠、高效</p>
          <div class="breadcrumb">
            <router-link to="/">首页</router-link>
            <span class="separator">/</span>
            <span class="current">检验检测服务</span>
          </div>
        </div>
      </div>
    </section>

   

    <!-- 检测分类主界面 -->
    <section class="detection-categories-main">
      <div class="container">
        <h2 class="section-title">检测分类</h2>
        <div class="categories-layout">
          <!-- 左侧分类列表 -->
          <div class="categories-sidebar">
            <div class="category-list">
              <div 
                v-for="category in serviceCategories" 
                :key="category.id"
                :class="['category-item', { active: activeTab === category.id }]"
                @click="setActiveTab(category.id)"
              >
                <div class="category-icon" style="margin: 0px;">
                  <i :class="category.icon"></i>
                </div>
                <div class="category-info">
                  <h3 class="category-name">{{ category.name }}</h3>
                 
                </div>
                <div class="category-arrow">
                  <i class="fas fa-chevron-right"></i>
                </div>
              </div>
            </div>
          </div>

          <!-- 右侧检测明细 -->
          <div class="detection-details">
            <div 
              v-for="category in serviceCategories" 
              :key="category.id"
              v-show="activeTab === category.id"
              class="category-details"
            >
              <div class="details-header">
                <h3 class="details-title">{{ category.name }}</h3>
                <p class="details-description">{{ category.description }}</p>
              </div>

              <div class="services-table-container">
                <!-- 桌面端表格 -->
                <table class="services-table">
                  <thead>
                    <tr>
                      <th>产品名称</th>
                      <th>产品标准</th>
                      <th>产品名称</th>
                      <th>产品标准</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in getTableRows(category.services)" :key="index">
                      <template v-if="row.left">
                        <td>{{ row.left.name }}</td>
                        <td>{{ row.left.price }}</td>
                      </template>
                      <template v-else>
                        <td></td>
                        <td></td>
                      </template>
                      <template v-if="row.right">
                        <td>{{ row.right.name }}</td>
                        <td>{{ row.right.price }}</td>
                      </template>
                      <template v-else>
                        <td></td>
                        <td></td>
                      </template>
                    </tr>
                  </tbody>
                </table>
                
                <!-- 移动端卡片布局 -->
                <div class="mobile-services-grid">
                  <div 
                    v-for="service in category.services" 
                    :key="service.id"
                    class="mobile-service-card"
                  >
                    <div class="mobile-service-header">
                      <div class="mobile-service-name">{{ service.name }}</div>
                      <div class="mobile-service-standard">{{ service.price }}</div>
                    </div>
                    <div v-if="service.description" class="mobile-service-description">
                      {{ service.description }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 其他检测分类 -->
    <section class="other-detection-categories">
      <div class="container">
        <h2 class="section-title">其他检测分类</h2>
        <div class="other-categories-grid">
          <div class="other-category-card">
            <div class="other-category-image">
              <img src="@/assets/img/ty1.webp" alt="建材检测" loading="lazy" decoding="async" />
            </div>
            <div class="other-category-content">
              <h3 class="other-category-title">建材</h3>
              <p class="other-category-description">
                提供各类建筑材料的质量检测服务，包括水泥、钢材、防水材料等，确保建筑工程质量安全。
              </p>
              <div class="other-category-features">
                <span class="feature-tag">质量检测</span>
                <span class="feature-tag">安全评估</span>
                <span class="feature-tag">标准认证</span>
              </div>
            </div>
          </div>

          <div class="other-category-card">
            <div class="other-category-image">
              <img src="@/assets/img/ty2.webp" alt="消防检测" loading="lazy" decoding="async" />
            </div>
            <div class="other-category-content">
              <h3 class="other-category-title">消防</h3>
              <p class="other-category-description">
                专业消防设备和系统检测，包括消防器材、报警系统、灭火系统等，保障消防安全。
              </p>
              <div class="other-category-features">
                <span class="feature-tag">设备检测</span>
                <span class="feature-tag">系统测试</span>
                <span class="feature-tag">安全认证</span>
              </div>
            </div>
          </div>

          <div class="other-category-card">
            <div class="other-category-image">
              <img src="@/assets/img/ty3.webp" alt="生活用品检测" loading="lazy" decoding="async" />
            </div>
            <div class="other-category-content">
              <h3 class="other-category-title">生活用品</h3>
              <p class="other-category-description">
                日常生活用品质量检测，包括家居用品、个人护理用品、食品接触材料等安全检测。
              </p>
              <div class="other-category-features">
                <span class="feature-tag">安全检测</span>
                <span class="feature-tag">质量评估</span>
                <span class="feature-tag">标准测试</span>
              </div>
            </div>
          </div>

          <div class="other-category-card">
            <div class="other-category-image">
              <img src="@/assets/img/ty4.webp" alt="电子电器检测" loading="lazy" decoding="async" />
            </div>
            <div class="other-category-content">
              <h3 class="other-category-title">电子电器</h3>
              <p class="other-category-description">
                电子电器产品安全性能检测，包括EMC测试、安全认证、能效检测等专业服务。
              </p>
              <div class="other-category-features">
                <span class="feature-tag">EMC测试</span>
                <span class="feature-tag">安全认证</span>
                <span class="feature-tag">能效检测</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

     <!-- 服务概览 -->
    <section class="services-overview">
      <div class="container">
        <div class="overview-content">
          <h2 class="section-title">服务概览</h2>
          <p class="section-description">
            作为专业的劳动防护产品检测中心，我们致力于检测，通过权威认证，我们在劳动防护体系中的重要一环，确保产品质量，
            助力劳动者安全。为企业提供专业的劳动防护产品检测服务，保护劳动者安全，防护产品，防护手套，防护鞋，防护服等。
          </p>
          <div class="stats-grid">
            <div class="stat-item">
              <div class="stat-number">50+</div>
              <div class="stat-label">防护产品类型</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">1000+</div>
              <div class="stat-label">企业客户</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">100%</div>
              <div class="stat-label">权威认证</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">7天</div>
              <div class="stat-label">出具报告</div>
            </div>
          </div>
        </div>
      </div>
    </section>



    <!-- 服务流程 -->
    <section class="service-process">
      <div class="container">
        <h2 class="section-title">服务流程</h2>
        <div class="process-steps">
          <div 
            v-for="(step, index) in processSteps" 
            :key="step.id"
            class="process-step"
          >
            <div class="step-number">{{ index + 1 }}</div>
            <div class="step-content">
              <h3 class="step-title">{{ step.title }}</h3>
              <p class="step-description">{{ step.description }}</p>
            </div>
            <div v-if="index < processSteps.length - 1" class="step-arrow">
              <i class="fas fa-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务优势 -->
    <section class="service-advantages">
      <div class="container">
        <h2 class="section-title">服务优势</h2>
        <div class="advantages-grid">
          <div 
            v-for="advantage in advantages" 
            :key="advantage.id"
            class="advantage-card"
          >
            <div class="advantage-icon">
              <i :class="advantage.icon"></i>
            </div>
            <h3 class="advantage-title">{{ advantage.title }}</h3>
            <p class="advantage-description">{{ advantage.description }}</p>
          </div>
        </div>
      </div>
    </section>



    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import servicesData from './servicesData.json'

export default {
  name: 'Services',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      activeTab: 'protective-clothing',
      serviceCategories: servicesData.serviceCategories.concat([







      ]),
      processSteps: [
        {
          id: 1,
          title: '产品咨询',
          description: '客户提供劳动防护产品信息，我们评估检测需求'
        },
        {
          id: 2,
          title: '检测方案',
          description: '根据产品类型制定专业的检测方案和标准'
        },
        {
          id: 3,
          title: '样品送检',
          description: '按照国家标准接收防护产品样品并登记'
        },
        {
          id: 4,
          title: '专业检测',
          description: '使用专业设备进行防护性能和安全指标检测'
        },
        {
          id: 5,
          title: '权威报告',
          description: '出具符合国家标准的权威检测报告'
        }
      ],
      advantages: [
        {
          id: 1,
          title: '专业资质',
          description: '具备劳动防护产品检测资质，专业技术团队经验丰富',
          icon: 'fas fa-users'
        },
        {
          id: 2,
          title: '标准检测',
          description: '严格按照国家标准进行检测，确保结果权威可靠',
          icon: 'fas fa-microscope'
        },
        {
          id: 3,
          title: '权威认证',
          description: 'CMA、CNAS等权威认证，检测报告具有法律效力',
          icon: 'fas fa-certificate'
        },
        {
          id: 4,
          title: '快速出报告',
          description: '高效检测流程，5-7个工作日出具检测报告',
          icon: 'fas fa-clock'
        },
        {
          id: 5,
          title: '安全保障',
          description: '专注工作场所安全，为企业员工安全保驾护航',
          icon: 'fas fa-shield-alt'
        },
        {
          id: 6,
          title: '全程服务',
          description: '从产品送检到报告出具，提供全程专业服务',
          icon: 'fas fa-heart'
        }
      ]
    }
  },
  methods: {
    selectCategory(categoryId) {
      this.activeTab = categoryId
    },
    setActiveTab(tabId) {
      this.activeTab = tabId
    },
    getTableRows(services) {
      const rows = []
      for (let i = 0; i < services.length; i += 2) {
        rows.push({
          left: services[i],
          right: services[i + 1] || null
        })
      }
      return rows
    },
    viewDetails(serviceId) {
      console.log('查看详情:', serviceId)
      // 这里可以跳转到服务详情页面
    }
  }
}
</script>

<style scoped>
.services-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

/* 容器样式 */
.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
}

@media (max-width: 1200px) {
  .container {
    max-width: 1200px;
    padding: 0 1.5rem;
  }
}

@media (max-width: 768px) {
  .container {
    padding: 0 1rem;
  }
}

/* 页面标题区域 */
.page-header {
  background: 
    linear-gradient(135deg, rgba(30, 64, 175, 0.4) 0%, rgba(59, 130, 246, 0.4) 50%, rgba(96, 165, 250, 0.4) 100%),
    url('@/assets/img/banner4.webp');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: scroll;
  color: white;
  padding: 140px 0 100px;
  position: relative;
  overflow: hidden;
  min-height: 400px;
}

/* 移动端背景适配：优化裁剪与空间 */
@media (max-width: 768px) {
  .page-header {
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    padding: 100px 0 60px;
    min-height: max(340px, calc(100vw * 9 / 16));
  }
}

.page-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(255,255,255,0.1)" stroke-width="0.5"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
  opacity: 0.3;
}

.header-content {
  position: relative;
  z-index: 2;
  text-align: center;
}

.page-title {
  font-size: 4rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  letter-spacing: -0.02em;
}

.page-subtitle {
  font-size: 1.5rem;
  opacity: 0.9;
  margin-bottom: 2.5rem;
  font-weight: 300;
}

.breadcrumb {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
}

.breadcrumb a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb a:hover {
  color: white;
}

.separator {
  opacity: 0.6;
}

.current {
  color: white;
  font-weight: 500;
}

/* 其他检测分类 */
.other-detection-categories {
  padding: 5rem 0;
  background: #f8fafc;
}

.other-categories-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.other-category-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
}

.other-category-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.other-category-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
  position: relative;
}

.other-category-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.other-category-card:hover .other-category-image img {
  transform: scale(1.05);
}

.other-category-content {
  padding: 2rem;
}

.other-category-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 1rem;
  text-align: center;
}

.other-category-description {
  color: #6b7280;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  text-align: center;
}

.other-category-features {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: center;
}

.other-category-features .feature-tag {
  background: linear-gradient(135deg, #3b82f6, #1e40af);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

/* 服务概览 */
.services-overview {
  padding: 5rem 0;
  background: white;
}

.overview-content {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 1.5rem;
  position: relative;
}

/* .section-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(135deg, #3b82f6, #1e40af);
  border-radius: 2px;
} */

.section-description {
  font-size: 1.125rem;
  color: #6b7280;
  line-height: 1.8;
  margin-bottom: 3rem;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.stat-item {
  text-align: center;
  padding: 2rem;
  background: linear-gradient(135deg, #f8fafc, #e2e8f0);
  border-radius: 20px;
  transition: transform 0.3s ease;
}

.stat-item:hover {
  transform: translateY(-5px);
}

.stat-number {
  font-size: 3rem;
  font-weight: 700;
  color: #3b82f6;
  margin-bottom: 0.5rem;
}

.stat-label {
  font-size: 1.125rem;
  color: #6b7280;
  font-weight: 500;
}

/* 服务分类 */
.service-categories {
  padding: 5rem 0;
  background: #f8fafc;
}

.categories-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.category-card {
  background: white;
  padding: 2.5rem;
  border-radius: 20px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
}

.category-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.category-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #3b82f6, #1e40af);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  font-size: 2rem;
  color: white;
}

.category-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 1rem;
}

.category-description {
  color: #6b7280;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.category-features {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: center;
}

.feature-tag {
  background: #e0f2fe;
  color: #0369a1;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 500;
}

/* 检测分类主界面 */
.detection-categories-main {
  padding: 6rem 0;
  background: #f8fafc;
}

.categories-layout {
  display: flex;
  gap: 2.5rem;
  margin-top: 3rem;
  min-height: 700px;
  align-items: flex-start;
}

/* 左侧分类列表 */
.categories-sidebar {
  flex: 0 0 320px;
  background: white;
  border-radius: 15px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  position: sticky;
  top: 2rem;
}

.category-list {
  display: flex;
  flex-direction: column;
}

.category-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  border-bottom: 1px solid #e5e7eb;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  min-height: 80px;
}

.category-item:hover {
  background: #f8fafc;
  transform: translateX(5px);
}

.category-item.active {
  background: linear-gradient(135deg, #3b82f6, #1e40af);
  color: white;
  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.3);
}

.category-item.active .category-arrow {
  color: white;
}

.category-icon {
  flex: 0 0 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
  border-radius: 12px;
  margin-right: 1rem;
  font-size: 1.5rem;
  color: #3b82f6;
  transition: all 0.3s ease;
}

.category-item.active .category-icon {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.category-info {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.category-name {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  color: #1f2937;
}

.category-item.active .category-name {
  color: white;
}

.category-desc {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0;
  line-height: 1.4;
}

.category-item.active .category-desc {
  color: rgba(255, 255, 255, 0.9);
}

.category-arrow {
  flex: 0 0 20px;
  color: #9ca3af;
  transition: all 0.3s ease;
}

/* 右侧检测明细 */
.detection-details {
  flex: 1;
  background: white;
  border-radius: 15px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 2.5rem;
  overflow-y: auto;
  max-height: calc(100vh - 200px);
}

.category-details {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.details-header {
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 2px solid #e5e7eb;
}

.details-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 1rem 0;
}

.details-description {
  font-size: 1.1rem;
  color: #6b7280;
  margin: 0 0 1.5rem 0;
  line-height: 1.6;
}

.category-features {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.feature-badge {
  background: linear-gradient(135deg, #3b82f6, #1e40af);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 25px;
  font-size: 0.875rem;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 1.5rem;
}

.service-card {
  background: #f8fafc;
  padding: 1.5rem;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
}

.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  border-color: #3b82f6;
}

.service-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.service-name {
  font-size: 1.2rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
  flex: 1;
}

.service-standard {
  background: #10b981;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 15px;
  font-size: 0.75rem;
  font-weight: 500;
  margin-left: 1rem;
}

.service-description {
  color: #6b7280;
  margin: 0 0 1.5rem 0;
  line-height: 1.6;
}

.service-features h5 {
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 0.75rem 0;
}

.features-list {
  list-style: none;
  padding: 0;
  margin: 0 0 1.5rem 0;
}

.features-list li {
  display: flex;
  align-items: center;
  padding: 0.5rem 0;
  color: #4b5563;
}

.features-list li i {
  color: #10b981;
  margin-right: 0.75rem;
  font-size: 0.875rem;
}

.service-actions {
  display: flex;
  gap: 1rem;
}

.service-actions .btn-primary,
.service-actions .btn-secondary {
  flex: 1;
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
}

/* 表格样式 */
.services-table-container {
  margin-top: 2rem;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e7eb;
}

.services-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.services-table thead {
  background: linear-gradient(135deg, #3b82f6, #1e40af);
}

.services-table thead th {
  color: white;
  padding: 1.25rem 1rem;
  text-align: center;
  font-weight: 600;
  font-size: 1rem;
  border: none;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.services-table tbody tr {
  border-bottom: 1px solid #e5e7eb;
  transition: background-color 0.2s ease;
}

.services-table tbody tr:hover {
  background-color: #f8fafc;
}

.services-table tbody tr:last-child {
  border-bottom: none;
}

.services-table tbody td {
  padding: 1rem 1.25rem;
  text-align: center;
  border-right: 1px solid #e5e7eb;
  color: #374151;
  vertical-align: middle;
}

.services-table tbody td:last-child {
  border-right: none;
}

.services-table tbody td:nth-child(odd) {
  font-weight: 500;
  color: #1f2937;
}

.services-table tbody td:nth-child(even) {
  color: #059669;
  font-weight: 500;
  font-size: 0.85rem;
}

/* 默认状态：桌面端显示表格，隐藏移动端卡片 */
.mobile-services-grid {
  display: none;
}

.services-table {
  display: table;
}

/* 详细服务列表 */
.detailed-services {
  padding: 5rem 0;
  background: white;
}

.service-tabs {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin: 3rem 0;
  flex-wrap: wrap;
}

.tab-btn {
  padding: 1rem 2rem;
  border: 2px solid #e5e7eb;
  background: white;
  color: #6b7280;
  border-radius: 50px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.tab-btn:hover {
  border-color: #3b82f6;
  color: #3b82f6;
  transform: translateY(-2px);
}

.tab-btn.active {
  background: linear-gradient(135deg, #3b82f6, #1e40af);
  color: white;
  border-color: transparent;
  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.3);
}

.service-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
}

.service-item {
  background: #f8fafc;
  padding: 2rem;
  border-radius: 15px;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
}

.service-item:hover {
  background: white;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transform: translateY(-5px);
}

.service-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.service-name {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
}

.service-price {
  background: linear-gradient(135deg, #3b82f6, #1e40af);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-weight: 500;
  font-size: 0.875rem;
}

.service-description {
  color: #6b7280;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.service-features {
  list-style: none;
  padding: 0;
  margin-bottom: 2rem;
}

.service-features li {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  color: #374151;
}

.service-features i {
  color: #10b981;
  font-size: 0.875rem;
}

.service-actions {
  display: flex;
  gap: 1rem;
}

.btn-primary, .btn-secondary {
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  flex: 1;
}

.btn-primary {
  background: linear-gradient(135deg, #3b82f6, #1e40af);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.3);
}

.btn-secondary {
  background: white;
  color: #3b82f6;
  border: 2px solid #3b82f6;
}

.btn-secondary:hover {
  background: #3b82f6;
  color: white;
}

/* 服务流程 */
.service-process {
  padding: 5rem 0;
  background: #f8fafc;
}

.process-steps {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  margin-top: 3rem;
  flex-wrap: wrap;
}

.process-step {
  display: flex;
  align-items: center;
  gap: 1rem;
  background: white;
  padding: 2rem;
  border-radius: 15px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  flex: 1;
  min-width: 250px;
  max-width: 300px;
}

.step-number {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #3b82f6, #1e40af);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.25rem;
  flex-shrink: 0;
}

.step-content {
  flex: 1;
}

.step-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.5rem;
}

.step-description {
  color: #6b7280;
  font-size: 0.875rem;
  line-height: 1.5;
}

.step-arrow {
  color: #3b82f6;
  font-size: 1.5rem;
  margin: 0 1rem;
}

/* 服务优势 */
.service-advantages {
  padding: 5rem 0;
  background: white;
}

.advantages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.advantage-card {
  text-align: center;
  padding: 2.5rem;
  background: #f8fafc;
  border-radius: 20px;
  transition: all 0.3s ease;
}

.advantage-card:hover {
  background: white;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transform: translateY(-5px);
}

.advantage-icon {
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, #3b82f6, #1e40af);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  font-size: 1.75rem;
  color: white;
}

.advantage-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 1rem;
}

.advantage-description {
  color: #6b7280;
  line-height: 1.6;
}





/* 响应式设计 */
@media (max-width: 1024px) {
  .categories-sidebar {
    flex: 0 0 280px;
    position: static;
  }
  
  .categories-layout {
    gap: 2rem;
    min-height: 600px;
  }
  
  .detection-details {
    padding: 2rem;
    max-height: none;
  }
}

@media (max-width: 768px) {
  .page-header {
    padding: 100px 0 60px;
  }
  
  .page-title {
    font-size: 2.5rem;
  }
  
  .page-subtitle {
    font-size: 1.2rem;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .detection-categories-main {
    padding: 3rem 0;
  }
  
  .categories-grid,
  .service-grid,
  .advantages-grid {
    grid-template-columns: 1fr;
  }
  
  /* 检测分类响应式 - 改为标签页式布局 */
  .categories-layout {
    flex-direction: column;
    gap: 0;
    min-height: auto;
  }
  
  .categories-sidebar {
    flex: none;
    max-height: none;
    overflow: visible;
    position: static;
    background: white;
    border-radius: 15px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    margin-bottom: 1.5rem;
    padding: 1rem;
    width: 100%;
  }
  
  .category-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
    width: 100%;
  }
  
  .category-item {
    padding: 1rem 0.75rem;
    width: 100%;
    height: 100px;
    border-radius: 16px;
    background: #f8fafc;
    border: 2px solid transparent;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }
  
  .category-item.active {
    background: linear-gradient(135deg, #3b82f6, #1e40af);
    border-color: transparent;
    transform: scale(1.02);
    box-shadow: 0 8px 25px rgba(59, 130, 246, 0.3);
  }
  
  .category-item.active .category-icon {
    color: white;
    background: rgba(255, 255, 255, 0.2);
  }
  
  .category-item.active .category-name {
    color: white;
  }
  
  .category-item:hover:not(.active) {
    background: #e5e7eb;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  }
  
  .category-icon {
    flex: 0 0 40px;
    height: 40px;
    font-size: 1.2rem;
    margin-right: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #3b82f6;
    transition: color 0.3s ease;
    background: rgba(59, 130, 246, 0.1);
    border-radius: 8px;
  }
  
  .category-info {
    text-align: left;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  
  .category-name {
    font-size: 0.9rem;
    line-height: 1.3;
    font-weight: 500;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 2.6em;
  }
  
  .category-desc {
    display: none;
  }
  
  .category-arrow {
    display: none;
  }
  
  .detection-details {
    padding: 1.5rem;
    margin-top: 0;
  }
  
  .details-title {
    font-size: 1.5rem;
  }
  
  .details-description {
    font-size: 1rem;
  }
  
  /* 表格响应式 - 改为卡片式布局 */
  .services-table-container {
    margin-top: 1.5rem;
    overflow: visible;
  }
  
  .services-table {
    display: none; /* 隐藏原表格 */
  }
  
  /* 移动端卡片式布局 */
  .mobile-services-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .mobile-service-card {
    background: #f8fafc;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 1.25rem;
    transition: all 0.3s ease;
  }
  
  .mobile-service-card:hover {
    background: white;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }
  
  .mobile-service-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 0.75rem;
    gap: 1rem;
  }
  
  .mobile-service-name {
    font-size: 1rem;
    font-weight: 600;
    color: #1f2937;
    flex: 1;
    line-height: 1.3;
  }
  
  .mobile-service-standard {
     background: linear-gradient(135deg, #10b981, #059669);
     color: white;
     padding: 0.25rem 0.75rem;
     border-radius: 15px;
     font-size: 0.75rem;
     font-weight: 500;
     white-space: nowrap;
     flex-shrink: 0;
   }
   
   .mobile-service-description {
     color: #6b7280;
     font-size: 0.875rem;
     line-height: 1.4;
     margin-top: 0.5rem;
   }
   
   /* 桌面端显示表格，隐藏卡片 */
   .mobile-services-grid {
     display: none !important;
   }
   
   .services-table {
     display: table !important;
   }
  
  .services-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .service-card {
    padding: 1.25rem;
  }
  
  .service-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .service-standard {
    margin-left: 0;
  }
  
  .service-actions {
    flex-direction: column;
  }
  
  .process-steps {
    flex-direction: column;
  }
  
  .step-arrow {
    transform: rotate(90deg);
  }
  
  .service-tabs {
    gap: 0.5rem;
  }
  
  .tab-btn {
    padding: 0.75rem 1.5rem;
    font-size: 0.875rem;
  }
  
  /* 移动端显示卡片，隐藏表格 */
  .services-table {
    display: none !important;
  }
  
  .mobile-services-grid {
    display: grid !important;
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 1rem;
  }

  /* 其他检测分类移动端样式 */
  .other-detection-categories {
    padding: 3rem 0;
  }

  .other-categories-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    margin-top: 2rem;
  }

  .other-category-content {
    padding: 1.5rem;
  }

  .other-category-title {
    font-size: 1.25rem;
  }

  .other-category-description {
    font-size: 0.9rem;
  }

}

@media (max-width: 480px) {
  .page-header {
    padding: 80px 0 50px;
  }
  
  .page-title {
    font-size: 2rem;
  }
  
  .page-subtitle {
    font-size: 1rem;
  }
  
  .detection-categories-main {
    padding: 3rem 0;
  }
  
  .categories-layout {
    gap: 1rem;
  }
  
  .category-list {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
  
  .detection-details {
    padding: 1.5rem;
  }
  
  .details-title {
    font-size: 1.5rem;
  }
  
  .category-item {
    padding: 0.75rem 0.5rem;
    width: 100%;
    height: 90px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
  }
  
  .category-icon {
    flex: 0 0 36px;
    height: 36px;
    font-size: 1rem;
    margin-right: 0.5rem;
    background: rgba(59, 130, 246, 0.1);
    border-radius: 6px;
  }
  
  .category-name {
    font-size: 0.75rem;
  }
  
  .category-name {
    font-size: 0.9rem;
  }
  
  .service-categories,
  .detailed-services,
  .service-process,
  .service-advantages {
    padding: 3rem 0;
  }
  
  .category-card,
  .service-item,
  .advantage-card {
    margin: 0 1rem;
  }
  
  .process-step {
    margin: 0 1rem;
  }
}
</style>